module.exports = __webpack_public_path__ + "static/img/3.609bb8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner1/3.png
// module id = RRSO
// module chunks = 14